import { useLayoutEffect, useState } from "react";

export default function useWindowSize(): number[] {
  const [size, setSize] = useState<number[]>(() => {
    if (!global.window) return [0, 0];

    return [window.innerWidth, window.innerHeight];
  });

  useLayoutEffect(() => {
    if (!global.window) return;

    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }

    window.addEventListener("resize", updateSize);
    updateSize();

    return () => window.removeEventListener("resize", updateSize);
  }, []);

  return size;
}
